export const GET_PROMO_YOUTUBE = 'GET_PROMO_YOUTUBE';
export const SET_PROMO_YOUTUBE = 'SET_PROMO_YOUTUBE';
export const ERROR_PROMO_YOUTUBE = 'ERROR_PROMO_YOUTUBE';